module.exports = __webpack_public_path__ + "img/img-10.c102b180.png";